import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class QuizRest {
  getQuizByLearningObject(
    objectiveId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/student-quiz`;
    return api.get(url, params);
  }

  returnQuestionsByQuiz(
    objectiveId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/student-quiz/start`;
    return api.post(url, {}, params);
  }

  checkItemAnswer(objectiveId: string, data: any): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/student-quiz/check-answer`;
    return api.post(url, data);
  }

  checkItemAbstractAnswer(objectiveId: string, data: any): Observable<any> {
    const url: string = `learning-objectives/${objectiveId}/student-quiz/check-answer`;
    const baseURL = "/api_v2";
    return api.post(url, data, {}, baseURL);
  }

  getQuizResult(
    objectiveId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/student-quiz/result`;
    return api.get(url, params);
  }

  getQuizByTeacher(objectiveId: string): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/quiz`;
    return api.get(url);
  }

  createQuiz(objectiveId: string, data: any): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/quiz`;
    return api.post(url, data);
  }

  updateQuiz(objectiveId: string, data: any): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/quiz`;
    return api.put(url, data);
  }

  getQuestionsDefaultByQuiz(
    quizId: string,
    params: QueryParams
  ): Observable<any> {
    const url: string = `/quiz/${quizId}/questions`;
    return api.get(url, params);
  }

  getQuestionsByQuiz(quizId: string, params: QueryParams): Observable<any> {
    const url: string = `/quiz/${quizId}/questions`;
    const baseURL = "/api_v2";
    return api.get(url, params, baseURL);
  }

  getQuestionDefaultById(quizId: string, questionId: string): Observable<any> {
    const url: string = `/quiz/${quizId}/questions/${questionId}`;
    return api.get(url);
  }
  getQuestionById(quizId: string, questionId: string): Observable<any> {
    const url: string = `/quiz/${quizId}/questions/${questionId}`;
    const baseURL = "/api_v2";
    return api.get(url, {}, baseURL);
  }

  createQuestion(quizId: string, data: any): Observable<any> {
    const url: string = `/quiz/${quizId}/questions`;
    const baseURL = "/api_v2";
    return api.post(url, data, {}, baseURL);
  }

  createDefaultQuestion(quizId: string, data: any): Observable<any> {
    const url: string = `/quiz/${quizId}/questions`;
    return api.post(url, data, {});
  }

  updateDefaultQuestion(
    quizId: string,
    questionId: string,
    data: any
  ): Observable<any> {
    const url: string = `/quiz/${quizId}/questions/${questionId}`;
    return api.put(url, data);
  }
  updateQuestion(
    quizId: string,
    questionId: string,
    data: any
  ): Observable<any> {
    const url: string = `/quiz/${quizId}/questions/${questionId}`;
    const baseURL = "/api_v2";
    return api.put(url, data, {}, baseURL);
  }

  deleteDefaultQuestion(quizId: string, questionId: string): Observable<any> {
    const url: string = `/quiz/${quizId}/questions/${questionId}`;
    return api.delete(url);
  }

  deleteQuestion(quizId: string, questionId: string): Observable<any> {
    const url: string = `quiz/${quizId}/questions/${questionId}`;
    const baseURL = "/api_v2";
    return api.delete(url, baseURL);
  }

  finalizeQuiz(
    courseId: string,
    userId: string,
    data: any,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `course-state/${courseId}/${userId}/add-quiz-event`;
    return api.post(url, data, params, "/graphs");
  }

  importQuestions(quizId: string, data: any): Observable<any> {
    const url: string = `/quiz/${quizId}/questions/import`;
    return api.post(url, data);
  }

  quizAndLearningEvent(
    courseId: string,
    userId: string,
    data: any,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `course-state/${courseId}/${userId}/add-quiz-objective-event`;
    return api.post(url, data, params, "/graphs");
  }
}
